// 判断操作终端类型
const isMobile = () => {
    let userAgentInfo = navigator.userAgent
    let Agents = ['Android', 'iPhone', 'SymbianOS', 'windows Phone', 'iPad', 'iPod']
    let getArr = Agents.filter(i => userAgentInfo.includes(i))
    return getArr.length ? true : false
}
export {
    isMobile
}


// WEBPACK FOOTER //
// ./src/libs/util.js